<template>
<div class="signinApp" id="signin">
  <h1>{{ $t("Signin.title") }}</h1>
  <!-- エラーメッセージ -->
  <table class="msgT" v-if="no > 0">
  <tr>
    <td class="msg"><p v-html="getErrorMsg"></p></td>
  </tr>
  </table>
  <!-- サインイン -->
  <div class="login-div e-blue">
    <div class="login-form-origin">
      <h3>{{ $t("Signin.name") }}:</h3>
      <input class="user-input" type="text" id="name" v-model="signin.name" required>
      <h3>{{ $t("Signin.password") }}:</h3>
      <input class="user-input" type="password" id="password" v-model="signin.password" required>
      <button class="sub-btn c-blue" v-on:click="submitSignin">{{ $t("Signin.signin") }}</button>
      <div class="errorMsg"><span>{{ getMsg }}</span></div>
      <p class="forgot-pass"><a :href="forgot">Forgot Your Password?</a></p>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'signin',
  data () {
    return {
      signin: {
        name: '',
        password: '',
      },
      forgot: process.env.VUE_APP_FORGOT_URL, // Cognito-forgot URL
      message: '',
      errFig: false,   // Cognitoサインインエラーフラグ
      required: false, // 必須エラーフラグ
      no: '',          // クエリパラメータ
    }
  },

  /*
   * created: 初期処理
   */
  created : function(){
console.log('Signin - created');
    this.no = this.$route.params.no;
console.log(this.$route);
  },

  /*
   * methods: メソッド
   */
  methods: {
    // サインインボタン押下
    submitSignin() {
      this.required = false;
      this.errFig = false;
      this.message = '';

      // 入力チェック
      if (!this.signin.name || !this.signin.password) {
        this.required = true;
        return false; 
      }

      // Cognitサインイン
      this.$cognito.signin(this.signin.name, this.signin.password).then(result => { // eslint-disable-line
        var url = this.$route.query.redirect
        if (url) {
          this.$router.replace(url)
        } else {
          this.$router.replace('/search')
        }
      })
      .catch(err => {
        console.log(err);
        this.message = err.message;
        if (err.message === 'Network error') {
          this.errFig = true;
        }
      });
    },
  },

  /*
   * computed: 算出プロパティ
   */
  computed: {
    getMsg: function() {
      // 必須入力エラー発生時
      if (this.required) {
        return this.$t("Message.MSG001");
      }

      // Cognitoネットワーク切断エラー返却時
      if (this.errFig) {
        return this.$t("Message.MSG009");
      }

      // サインインエラー返却時
      if (this.message) {
        return this.message;
      }

      // エラーなし
      return "";
    },
    // グループ設定漏れエラー
    getErrorMsg: function() {
      if (this.no === 1) {
        return this.$t("Message.MSG010");
      }

      // エラーなし
      return "";
    },
  },
}
</script>

<style>
/*--------------------
   COLOURS
--------------------*/
.e-blue {
  //background-color: #1581BA;
  background-color: #4169e1;
}

.c-blue {
  //background-color: #12B5E4;
  background-color: #87ceeb;
}

/*--------------------
    BASIC CLASSES
--------------------*/
.signinApp {
  max-width: 640px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

/*--------------------
    MODAL STYLING
--------------------*/
.login-div {
  width: 640px;
  height: 400px;
  display: flex;
  //boder: 1pt;
  justify-content: center;
  align-items: center;
}

.login-form-origin {
  width: 80%;
}

/*--------------------
    FORM STYLING
--------------------*/
.user-input, .user-input:focus {
  width: 100%;
  height: 35px;
  border: none;
  border-bottom: 2px solid #FFFFFF;
  background-color: transparent;
  outline: none;
  color: #FFFFFF;
  padding-left: 5px;
  font-size: 20px;
}

.user-input:-webkit-autofill {
  box-shadow: 0 0 0 1000px #4169e1 inset;
  -webkit-text-fill-color: white !important;
}

.sub-btn {
  width: 100%;
  height: 35px;
  color: #FFFFFF;
  font-size: 20px;
  border: none;
  margin-top: 20px;
  cursor: pointer;
}

.errorMsg {
  text-align: left;
  color: #ffff00;
  line-height: 22px;
}

.forgot-pass {
  margin-top: 20px;
  text-align: left;
}

.msgT {
  border: none;
}

.msg {
  text-align: left;
  line-height: 22px;
  color: #ff0000;
  boder: none;
}
</style>
